/** Router error screen: reloads into a newer build when that's the cause, otherwise says what to do. */
import { useEffect, useState } from 'react';
import { Link, useRouteError } from 'react-router';
import { Button, EmptyState } from '../components/ui';
import { reloadIfStale } from '../lib/buildCheck';

export function RouteError() {
  const error = useRouteError();
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    let alive = true;
    void reloadIfStale().then((reloading) => { if (alive && !reloading) setChecking(false); });
    return () => { alive = false; };
  }, []);
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  if (checking) return <div className="page page--center"><EmptyState icon="refresh" title="Updating Airview Studio…" body="Loading the latest version." /></div>;
  return (
    <div className="page page--center">
      <EmptyState
        icon="alert"
        title="Something went wrong on this screen"
        body={<>Reload to try again. If it keeps happening, go back to your shoots.{message ? <code className="route-error__detail">{message}</code> : null}</>}
        action={
          <div className="empty__actions">
            <Button variant="primary" icon="refresh" onClick={() => location.reload()}>
              Reload
            </Button>
            <Link className="btn btn--secondary btn--md" to="/missions">
              <span className="btn__label">Back to shoots</span>
            </Link>
          </div>
        }
      />
    </div>
  );
}
